import { useTranslation } from 'react-i18next';
import { ReactSVG } from 'react-svg';
import downloadIcon from '@web/utils/src/assets/icons/functions/download-icon.svg';
import pdfIcon from '@web/utils/src/assets/icons/functions/pdf-icon.svg';
import { POrderDocument } from '@/pages/FarmerPages/DocumentsPages/OrderDetailsPage/OrderDetailsPage';

export interface OrderDocumentProps {
  document: POrderDocument;
}
const OrderDocument = (props: OrderDocumentProps) => {
  const { document } = props;
  const { t } = useTranslation();

  const HandleDocumentDownload = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <div
      key={document.id}
      className="p-1-6 rounded-8-0 border-2 border-secondary-grey"
    >
      <div className="flex items-center mb-1-6">
        <ReactSVG src={pdfIcon} className="mr-1-6" />
        <p className="font-bd">{document.type}</p>
      </div>
      <div
        className="flex justify-between items-center md:text-1-3 text-1-6 cursor-pointer"
        onClick={() => HandleDocumentDownload(document.url)}
      >
        <p>{t('orders.download')}</p>
        <ReactSVG src={downloadIcon} className="download-icon text-white" />
      </div>
    </div>
  );
};

export default OrderDocument;
